export default __webpack_public_path__ + "static/yahooFinance-11b62f15bf771211b1a58bc7ce838c09.png";